import * as React from "react";
const SvgIcon62 = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="1em" height="1em" viewBox="0 0 22 17" {...props}><rect width={22} height={17} rx={8.5} style={{
    fill: "var(--text-color-1,#000)",
    fillOpacity: 1
  }} /><path d="M8.92 12.41h1.76l-2.7-7.75h-1.9l-2.69 7.75h1.62l.6-1.848h2.724l.586 1.848ZM6.93 6.271h.1l.96 3.039H5.96l.97-3.039Zm10.046 6.139h1.756L16.04 4.66h-1.907l-2.694 7.75h1.63l.597-1.848h2.723l.586 1.848Zm-1.988-6.139h.097l.961 3.039h-2.03l.972-3.039Z" style={{
    fill: "var(--content-background-color,#fff)",
    fillOpacity: 1
  }} /></svg>;
export default SvgIcon62;